// Origine da cui prendere le /api/*. Vive qui e non in main.jsx perché serve
// anche a chi costruisce URL che NON passano dal fetch: il <video src> di
// AirPlay, per esempio, deve essere assoluto perché è la Apple TV a scaricarlo.
//
// `vite preview` serve il bundle di produzione, quindi import.meta.env.DEV è false:
// senza questo controllo ogni /api/ diventava l'URL assoluto https://notflix.it/api/...,
// scavalcando il proxy `preview` di vite.config.js. La richiesta partiva cross-origin con
// credentials: 'include', che il browser rifiuta perché il server risponde con
// Access-Control-Allow-Origin: * (server/server.js usa cors() senza opzioni) e senza
// Access-Control-Allow-Credentials; il cookie stream_token, inoltre, non sarebbe stato
// inviato. Da qui gli "errori di connessione" in preview.
// Se la pagina arriva da un host locale CON porta siamo su vite dev/preview (5173/4173,
// anche via --host sull'IP di LAN) e conviene restare su path relativi per usare il proxy.
// La porta è determinante: la WebView di Capacitor serve da http://localhost senza porta,
// e lì il path relativo non avrebbe nessun proxy dietro.
const LOCAL_HOSTS = /^(localhost|127\.0\.0\.1|\[?::1\]?|0\.0\.0\.0|192\.168\.\d+\.\d+|10\.\d+\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)$/;
const isViteServer = LOCAL_HOSTS.test(window.location.hostname) && window.location.port !== '';

export const API_BASE = (import.meta.env.DEV || isViteServer) ? '' : 'https://notflix.it';

// Rende assoluto un path /api/... . In dev/preview API_BASE è vuoto e si ricade
// sull'origine della pagina, che è quella del proxy di vite.
export const toAbsoluteApiUrl = (path) => new URL(path, API_BASE || window.location.origin).toString();
